(() => {
  "use strict";

  const root = document.querySelector(".aibo-lp");
  if (!root) return;

  /* =========================
     商品カラー切り替え
  ========================= */

  const variants = {
    black: {
      image: "product-black.jpg",
      name: "BLACK",
      alt: "WORK BAG aibō ブラック",
      id: "50895076917554"
    },

    khaki: {
      image: "product-khaki.jpg",
      name: "KHAKI-BEIGE",
      alt: "WORK BAG aibō カーキベージュ",
      id: "51174586286386"
    }
  };

  const image = root.querySelector("#aibo-color-image");
  const assetBase = image.src.slice(0, image.src.lastIndexOf("/") + 1);
  const link = root.querySelector("#aibo-product-link");

  root.querySelectorAll("[data-color]").forEach(button => {
    button.addEventListener("click", () => {
      const selected = variants[button.dataset.color];
      if (!selected) return;

      image.src = assetBase + selected.image;
      image.alt = selected.alt;

      root.querySelectorAll("[data-color]").forEach(item => {
        item.setAttribute(
          "aria-pressed",
          String(item === button)
        );
      });

      root.querySelector(".aibo-color-status").textContent =
        selected.name + " の商品画像を表示中";

      link.href =
        "https://shop.capola.jp/products/work-bag-aibo?variant=" +
        selected.id;
    });
  });


  /* =========================
     STYLE 01 自動スライダー
  ========================= */

  const styleSlider = root.querySelector(".aibo-style-auto-slider");

  if (
    styleSlider &&
    !window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) {
    const slides = styleSlider.querySelectorAll("img");
    let currentIndex = 0;

    setInterval(() => {
      slides[currentIndex].classList.remove("is-active");

      currentIndex = (currentIndex + 1) % slides.length;

      slides[currentIndex].classList.add("is-active");
    }, 2000);
  }


  /* =========================
     Sticky
  ========================= */

  const sticky = root.querySelector(".aibo-sticky");

  if ("IntersectionObserver" in window) {
    let heroVisible = true;
    let shopVisible = false;

    const update = () => {
      sticky.hidden = heroVisible || shopVisible;
    };

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target.classList.contains("aibo-hero")) {
          heroVisible = entry.isIntersecting;
        } else {
          shopVisible = entry.isIntersecting;
        }
      });

      update();
    });

    observer.observe(root.querySelector(".aibo-hero"));
    observer.observe(root.querySelector(".aibo-shop"));
  }
})();